import React from 'react';
import leftArrow from '../../../../assets/img/white-left-icon.svg';
import closeCross from '../../../../assets/img/close-cross.svg';
import loginLogo from '../../../../assets/img/login-logo2.svg';
import logoHover from '../../../../assets/img/login-logohover.svg';
import logoHover2 from '../../../../assets/img/login-logohover2.svg';
import { useNavigate } from 'react-router-dom';

const EstimationHeader = ({
  content,
  handleBack,
  currentStep,
  isEditing = false,
  isEditQuoteFlow = false,
  isPreview = false,
  currentQuoteId
}) => {
  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleLogoClick = () => {
    navigate('/projects'); // Redirect to the home page
  };
  return (
    <header className="header">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="header-content">
              {currentStep === 1 ? (
                <a className="happyLogo-cover">
                  <img src={loginLogo} alt="Happy Ending" className="happy-logo" onClick={handleLogoClick} />
                  <img src={logoHover} alt="Happy Ending" className="happy-logo2" onClick={handleLogoClick} />
                  <img
                    src={logoHover2}
                    alt="Happy Ending"
                    className="happy-logo2 hover-happy-logo2"
                    onClick={handleLogoClick}
                  />
                </a>
              ) : currentStep === 3 && currentQuoteId && !isPreview ? (
                <div></div>
              ) : (
                <div className="back-btn cursor_pointer" onClick={handleBack}>
                  <img src={leftArrow} alt="back" className="left-arrow" />
                </div>
              )}
              <h2>
                {isEditing
                  ? 'Edit Change Order'
                  : isEditQuoteFlow
                    ? 'Edit an estimate'
                    : isPreview && currentStep === 3
                      ? 'Proposal'
                      : 'Create an estimate'}{' '}
              </h2>
              <div className="head-right">
                <a
                  onClick={() => {
                    window.close();
                  }}>
                  <img src={closeCross} alt="close" className="left-arrow" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default EstimationHeader;
